const EGDSSheetPositionTypes = {
  LEADING: 'leading',
  TRAILING: 'trailing'
};
const EGDSSideSheetColCountsMap = [[1, '1'], [2, '2'], [3, '3'], [4, '4'], [6, '6'], [8, '8'], [12, '12']];
const EGDSSideSheetColCounts = new Map(EGDSSideSheetColCountsMap);
export { EGDSSheetPositionTypes, EGDSSideSheetColCounts };